<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns" [routerLink]="['/pos/employee/manage']">Manage Employee</button>
                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t">View Employee</a>
                                </div>
                                <div class="pt-3">
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1"> First Name </div>

                                        <div class="col-7 view-text"> {{rows.FirstName}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Last Name</div>

                                        <div class="col-7 view-text"> {{rows.LastName}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1"> Email </div>

                                        <div class="col-7 view-text"> {{rows.Email}}</div>
                                    </div>


                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1"> Mobile Number </div>

                                        <div class="col-7 view-text"> {{ rows.PhoneNo }}</div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Employee Id</div>

                                        <div class="col-7 view-text"> {{rows.EmployeeId}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1"> Role</div>

                                        <div class="col-7 view-text"> {{rows.Role}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Date Time</div>

                                        <div class="col-7 view-text"> {{rows.dateTime | date:'d/M/yy, h:mm a'}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Pass Code</div>

                                        <div class="col-7 view-text"> {{rows.PassCode}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Nick Name</div>

                                        <div class="col-7 view-text"> {{rows.NickName}}</div>
                                    </div>
                                    <div class="text-right py-2">
                                        <button class="btn dash-btns  " [routerLink]="['/pos/employee/manage']">Back</button>
                                                                       
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>